/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpgradeDeploymentStatusEnum } from './upgradeDeploymentStatusEnum';
import { LastUpgrade } from './lastUpgrade';


export interface UpgradeStatusResult { 
    id: string;
    status: UpgradeDeploymentStatusEnum;
    update_result: LastUpgrade;
}
export namespace UpgradeStatusResult {
}


